export default [
  {
    text: 'Name',
    value: 'name',
    order: 1,
    sortable: true,
    hidable: false,
    hidden: false,
  },
  {
    text: 'Color',
    value: 'color',
    align: 'left',
    sortable: false,
    order: 2,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Type',
    value: 'statusType',
    align: 'left',
    sortable: false,
    order: 3,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Actions',
    value: 'actions',
    align: 'right',
    sortable: false,
    order: 3,
    hidable: true,
    hidden: false,
    width: '92px',
  },
];
